import {Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {GridsterConfig, GridsterItem, GridType} from 'angular-gridster2';

import {ConfigService} from '../../services/config/config.service';
import {GridService} from '../../services/grid/grid.service';

/**
 * Creates the grid controller that allows the widget dialog boxes to move around/resize
 */
@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})
export class GridComponent implements OnInit {
  // The options for ng-gridster2
  public options: GridsterConfig;
  // The array of items currently active on the grid
  public dashboard: Array<GridsterItem>;
  // The maximum height of a widget based off screen size
  public maxHeight: number;

  constructor(public config: ConfigService, private grid: GridService, private cd: ChangeDetectorRef) { }

  private widgetChangeObserver;
  /**
   * Initializes the variables required to run ng-gridster2 and then runs the startup protocol in the grid service
   */
  ngOnInit() {
    this.resize();
    const modifier =  window.innerWidth / 1920;
    const hmod = window.innerHeight / 1080 / .8;
    this.options = {
      gridType: GridType.Fit,
      displayGrid: 'none',
      minCols: 40 * modifier,
      maxCols: 100,
      minRows: 40 * hmod,
      maxRows: 100,
      margin: 15,
      pushItems: true,
      mobileBreakpoint: 800,
      disableWarnings: true,
      useTransformPositioning: true,
      draggable: {
        enabled: true,
        ignoreContentClass: 'dialog-content'
      },
      resizable: {
        enabled: true
      }
    };
    this.widgetChangeObserver = this.grid.getWidgetChangeObs().subscribe( () => {
      this.dashboard = this.grid.getGrid();
      this.cd.detectChanges();
    });

    this.dashboard = this.grid.getGrid();
    this.grid.startGrid();
  }

  ngOnDestroy(): void {
    if (this.widgetChangeObserver) { this.widgetChangeObserver.unsubscribe(); }
  }

  /**
   * Makes sure that the gridster items can't grow larger than the screen
   */
  public resize() {
    if (window) {
      this.maxHeight = window.innerHeight - 15;
    }
  }
}
